import React from "react";
import { Row, Col, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import { TfiSplitVAlt } from "react-icons/tfi";
import SoundBasic from "component/component/sound_basic";
import {
  setBailiffDialogKick,
  setBailiffDialogPlay,
  setBailiffDialogSlot,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import {
  bailiffDialogOptionSpeakerSelector,
  bailiffDialogPlaySelector,
  bailiffDialogSecondSelector,
  // bailiffDialogSlotSelector,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";

import { refineSpecificTimer } from "util/refine_timer.function";
import { COLORS_SPEAKER } from "store/string";
import moment from "moment";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const CardBailiffDialog = ({ data, order = 0 }) => {
  // -------------------------- VAR -----------------------------

  const speaker = data?.fixSpeaker || data?.speaker || "";
  const isUpdated =
    data?.update || (data?.fix !== undefined && data?.fix !== "") || false;
  const from = isUpdated ? data?.fixFrom || 0 : data?.from || 0;
  const to = isUpdated ? data?.fixTo || 0 : data?.to || 0;
  const labelForm = refineSpecificTimer({ timer: from });
  const labelTo = refineSpecificTimer({ timer: to });
  const duration = `${labelForm} → ${labelTo}`;
  const text = data?.fix || data?.text || "";
  console.log({ data });

  // -------------------------- STATE ---------------------------
  // const [content, setContent] = useState("");
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // const index = useSelector(bailiffDialogSlotSelector);
  const play = useSelector(bailiffDialogPlaySelector);
  const second = useSelector(bailiffDialogSecondSelector);
  const options = useSelector(bailiffDialogOptionSpeakerSelector);

  // const chosen = index === order;
  const number = options?.findIndex((o) => o === speaker) || 0;
  const color = COLORS_SPEAKER?.[number] || "#f2f2f2";
  const chosenSen = second >= from && second <= to;

  // -------------------------- FUNCTION ------------------------
  const onClick = () => {
    const time = `change-${moment()?.valueOf()}-${from}`;
    dispatch(setBailiffDialogPlay(!play));
    dispatch(setBailiffDialogKick(time));
    dispatch(setBailiffDialogSlot(order));
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  const renderContent = () => {
    return <p style={{ lineHeight: "20px" }}>{text}</p>;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row>
      <Col style={{ padding: 5 }} xl={24} lg={24} md={24} xs={24}>
        <Space>
          <b
            style={{
              color: "black",
              background: color,
              padding: 5,
              borderRadius: 5,
            }}
          >
            Người nói {speaker}
          </b>
        </Space>
      </Col>
      <Col style={{ padding: 5 }} xl={24} lg={24} md={24} xs={24}>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div className="italic text-gray-500">{duration}</div>
          <SoundBasic chosen={chosenSen} onClick={onClick} play={play} />
        </div>
        {renderContent()}
      </Col>
    </Row>
  );
};
export default CardBailiffDialog;
